import { animate, state, style, transition, trigger } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, LOCALE_ID, OnInit, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { StompSubscription } from '@stomp/stompjs';
import { UUID } from 'angular2-uuid';
import { Subscription, interval, of, throwError, timer } from 'rxjs';
import { PaginationModel } from 'src/app/Models/pagination-model';
import { ReportModel } from 'src/app/Models/report-model';
import { ExecuteService } from 'src/app/Services/execute.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { ReportService } from 'src/app/Services/report.service';
import { RestService } from 'src/app/Services/rest.service';
import { SharedService } from 'src/app/Services/shared.service';
import { WebsocketService } from 'src/app/Services/websocket.service';
import { environment } from 'src/environments/environment';
import RFB from "../../../../node_modules/@novnc/novnc/core/rfb.js";
import { mergeMap, retryWhen, switchMap, takeWhile } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { UserService } from 'src/app/Services/user.service.js';
import { MobileStreamViewComponent } from '../mobile-stream-view/mobile-stream-view.component';
import { Literals } from 'src/app/literals.js';

@Component({
  selector: 'ze-report-view',
  templateUrl: './report-view.component.html',
  styleUrls: ['./report-view.component.scss'],
  providers: [DatePipe],
  animations: [
    trigger('dropdownState', [
      state('open', style({
        maxHeight: '500px',
        opacity: 1,
        visibility: 'visible'
      })),
      state('closed', style({
        maxHeight: '0',
        opacity: 0,
        visibility: 'hidden'
      })),
      transition('open => closed', [
        animate('0.3s ease-out')
      ]),
      transition('closed => open', [
        animate('0.3s ease-in')
      ])
    ])
  ]
})
export class ReportViewComponent implements OnInit {
  userExecutionId: string = "";
  stepNumberOpened: number = 0;
  selectedStepInStatistic: number = 0;
  totalPages: number = 0;
  showDiv: boolean = false;
  public isDropdownVisible: boolean = false;
  public isDropdownDisabled: boolean = false;
  public objectKeys = Object.keys;
  selectedBrowser: string = '';
  datasetAvailable: boolean = false;
  codeReviewAvailable: boolean = false;
  stepExecBrowserKeys: {} = {};
  lastStepInProgressBrowser: string = '';
  lastStepInProgressIteration: string = '';
  stepSelected: boolean = false;
  stepBrowserSelected = '';
  stepIterationSelected = '';
  updatingVideoUrl: boolean = false;
  isBrowserIterationDataAvailable = false;

  iterationOptions: string[] = ['1'];
  selectedIteration: string = this.iterationOptions[0];
  public secondsCounter;
  public counterSubs: Subscription;
  public reports: ReportModel[];
  public filterList: Array<ReportModel>;
  public index: number = 0;
  public currentReport: ReportModel = new ReportModel();
  public stepwiseReport: ReportModel = new ReportModel();
  public showVideo: Boolean;
  private getReportSubs: Subscription;
  public currentPage = 0;
  public currentPagedb2 = 0;
  public currentPageSchedule = 0;
  public size = 10;
  public showHTML: boolean = false;
  public showIFrame: boolean = false;
  private _value: number = 0;
  public searchText: string = "";
  public viewtype = '';
  displayedContent: string = '';
  public activeContent: string = 'statistic';
  public activeBtn: string = 'exe';
  showCreatedDiv: boolean = false;
  showExecutedDiv: boolean = false;
  showsortDiv: boolean = false;
  noExecutions: boolean = false;
  intialConnectionSuccessful: boolean = false;
  currentReportLoading: boolean = false;
  currentReportLoadFailed: boolean = false;
  private stompProjectExecutionInsertSubscription: StompSubscription;
  private stompProjectExecutionDeleteSubscription: StompSubscription;
  private stompProjectExecutionUpdateSubscription: StompSubscription;
  private stompProjectReportPageSubscription: StompSubscription;
  private stompSelectedReportSubscription: StompSubscription;
  private stompSelectedBrowserIterationSubscription: StompSubscription;
  private stompBrowserIterationUpdateSubscription: StompSubscription;

  isProjectManagementIntegrated: boolean = false;
  isProjectMapped: boolean = false;
  isUserQa: boolean = false;

  public paginationPage: PaginationModel;
  @ViewChildren('html_report') htmlframe: ElementRef;
  @ViewChild('log_report', { static: false }) logframe: ElementRef;
  @ViewChild('createdDiv', { static: false }) createdDivRef: ElementRef;
  @ViewChild('createdBtn', { static: false }) createdBtnRef: ElementRef;
  @ViewChild('executedDiv', { static: false }) executedDivRef: ElementRef;
  @ViewChild('executedBtn', { static: false }) executedBtnRef: ElementRef;
  @ViewChild('artifactDiv', { static: false }) artifactDivRef: ElementRef;
  @ViewChild('artifactBtn', { static: false }) artifactBtnRef: ElementRef;
  @ViewChild('sortDiv', { static: false }) sortDivRef: ElementRef;
  @ViewChild('sortBtn', { static: false }) sortBtnRef: ElementRef;
  @ViewChild('dateDiv', { static: false }) dateDivRef: ElementRef;
  @ViewChild('dateBtn', { static: false }) dateBtnRef: ElementRef;
  public showLiveFrame: boolean = false;
  user: string = "";
  dropdownState = 'closed';
  recentContentType = '';
  @ViewChild(MatDatepicker, { static: false }) datepicker: MatDatepicker<Date>;
  @ViewChild('mobileStream', { static: false }) mobileStreamComponent: MobileStreamViewComponent;
  video_url: any = null;
  videoNotFound: boolean = false;
  videoShareLink = "";
  currentLink: string = '';
  locked: boolean = false;
  currentLink2: string = '';
  locked2: boolean = false;
  mobileLocked: boolean = true;
  usernames: any = null;
  selectedCreatedUsers: { [key: string]: boolean } = {};
  selectedExecutedUsers: { [key: string]: boolean } = {};
  sortBy: string = "desc";
  showArtifact: any;
  artifacts: string[] = [];
  selectedArtifact: { [key: string]: boolean } = {};
  startedBy: string[] = [];
  createdBy: any;
  dateString: Date;
  isActive: Boolean = false;
  dateRangeForm: FormGroup;
  showDatePickers: Boolean = false;
  startDate: Date;
  endDate: Date;
  activeButtonColor: string;
  testArtifact: string[] = [];
  isIconDisabled = false;
  heartbeatInterval: any;
  heartbeatInterval2: any;

  //properties for video session 2
  video_url_2: any = null;
  videoNotFound2: boolean = false;
  updatingVideoUrl2: boolean = false;
  activeVideoSession: number = 1;

  // Appium stream properties
  appium_stream_url: any = null;

  // Add this property alongside isActive
  isScheduledFilter: boolean = false;
  activeScheduledButtonColor: string = 'white';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private executeService: ExecuteService,
    private reportService: ReportService,
    private userService: UserService,
    private _sharedService: SharedService,
    @Inject(LOCALE_ID) private locale: string,
    private ref: ChangeDetectorRef,
    private restService: RestService,
    private notifyservice: NotifyService,
    private http: HttpClient,
    private renderer: Renderer2,
    private el: ElementRef,
    private websocketService: WebsocketService,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private fb: FormBuilder,
    public dialog: MatDialog,
  ) {
    this.onChangePage = this.onChangePage.bind(this);
  }
  ngAfterContentInit() {
    let currentUser1 = JSON.parse(localStorage.getItem("currentUser")).token;
    this.user = this.parseJwt(JSON.stringify(currentUser1)).sub;

  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  };
  searchFilter() {
    if (this.viewtype == 'ide')
      this.getReportdb2s(this.size, 0, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
    else if (this.viewtype == Literals.SCHEDULE)
      this.getScheduledReports(this.size, 0, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
    else
      this.getReports(this.size, 0, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
  }

  getReports(size, page, searchText, sortBy, createdBy, executedBy, startDate, endDate, titleOnly, testArtifact) {
    this.noExecutions = false;
    let projectId = localStorage.getItem("projectId");
    let uuid: string = UUID.UUID();

    // When scheduled filter is OFF → pass false (only non-scheduled, default library behavior)
    // When scheduled filter is ON  → pass null  (all executions, library + scheduled)
    const scheduledParam = this.isScheduledFilter ? null : false;

    let data = { project: { _id: projectId }, 
    size: size, 
    page: page, 
    searchString: searchText, 
    uuid: uuid, 
    sort: { sortOrder: sortBy, sortBy: "start_time", isActive: titleOnly }, 
    filter: { startedBy: executedBy, createdBy: createdBy, startDate: startDate, endDate: endDate, testArtifacts: testArtifact},
    scheduled: scheduledParam } ;

    // New Execution Added Subscription
    if (this.stompProjectExecutionInsertSubscription) {
      this.stompProjectExecutionInsertSubscription.unsubscribe();
    }

    this.stompProjectExecutionInsertSubscription = this.websocketService.stompClient.subscribe('/message/db1/project/exeinsert/' + projectId, (message) => {
      this.websocketService._send(data);
    });

    if (this.stompProjectExecutionDeleteSubscription) {
      this.stompProjectExecutionDeleteSubscription.unsubscribe();
    }

    this.stompProjectExecutionDeleteSubscription = this.websocketService.stompClient.subscribe('/message/db1/exedelete', (message) => {
      this.websocketService._send(data);
    });

    if (this.stompProjectExecutionUpdateSubscription) {
      this.stompProjectExecutionUpdateSubscription.unsubscribe();
    }

    this.stompProjectExecutionUpdateSubscription = this.websocketService.stompClient.subscribe('/message/db1/project/exeupdate/' + projectId, (message) => {
      const updatedReport = JSON.parse(message.body).data;
      if (this.filterList && this.filterList.length > 0) {
        this.filterList.forEach((report, index) => {
          if ((report._id["$oid"] ? report._id["$oid"] : report._id) === (updatedReport._id["$oid"] ? updatedReport._id["$oid"] : updatedReport._id)) {
            this.filterList[index] = { ...report, ...updatedReport }; // Update the report with new data
          }
        });
      }
      // Check and update the current report if its _id matches the updated report's _id
      if (this.currentReport._id === updatedReport._id) {
        this.openReport(updatedReport);
      }
    });

    if (this.stompBrowserIterationUpdateSubscription) {
      this.stompBrowserIterationUpdateSubscription.unsubscribe();
    }

    this.stompBrowserIterationUpdateSubscription = this.websocketService.stompClient.subscribe('/message/db1/browserIteration/update', (message) => {
      const updatedBrowserIteration = JSON.parse(message.body).data;
      if (this.currentReport._id === updatedBrowserIteration.report_id["$oid"] ? updatedBrowserIteration.report_id["$oid"] : updatedBrowserIteration.report_id) {
        const liveStatus = this.currentReport.report_links.live_status;
        let updatedBrowser = '';
        let updatedIteration = '';
        for (const [browser, iterations] of Object.entries(liveStatus)) {
          // Iterate through each iteration
          for (const [iteration, value] of Object.entries(iterations)) {
            if (value['_id'] === updatedBrowserIteration['_id']) {
              updatedBrowser = browser;
              updatedIteration = iteration;
              break;
            }
          }
          if (updatedBrowser != '' && updatedIteration != '') {
            break;
          }
        }
        if (updatedBrowser != '' && updatedIteration != '') {
          this.currentReport.report_links.live_status[updatedBrowser][updatedIteration] = JSON.parse(message.body).data;
          this.openReport(this.currentReport);
          // this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
        }
      }
    });

    if (this.stompProjectReportPageSubscription) {
      this.stompProjectReportPageSubscription.unsubscribe();
    }
    this.stompProjectReportPageSubscription = this.websocketService.stompClient.subscribe('/message/db1/id/' + uuid + '/project/' + projectId + '/report/page/' + page, (message) => {
      // console.log("message db1",message);
      this.noExecutions = false;
      if (!(JSON.parse(message.body).operationStatus === "ERROR")) {
        if (JSON.parse(message.body).data['list'].length === 0) {
          this.noExecutions = true;
          this.reports = undefined;
        } else {
          this.reports = JSON.parse(message.body).data;
          this.filterList = JSON.parse(JSON.stringify(this.reports['list']))
          if (this.currentReport._id == null) {
            this.currentReportLoading = true;
            if (this.userExecutionId != undefined && this.userExecutionId != null) {
              this.getSelectedReportData(this.userExecutionId);
              this.userExecutionId = null;
            } else {
              this.currentReport = this.filterList[0];
              this.getSelectedReportData(this.filterList[0]._id);
            }
          }
          this.paginationPage = { size: this.reports["totalPages"], currentPage: page }
          this.totalPages = this.reports["totalPages"];
        }
      }
      // this._sharedService.loaderHide.emit(false);
    });
    return this.websocketService._send(data);
  }

  getReportdb2s(size, page, searchText, sortBy, createdBy, executedBy, startDate, endDate, titleOnly, testArtifact) {
    this.noExecutions = false;
    let projectIdDb2 = localStorage.getItem("projectIdDb2");
    let uuid: string = UUID.UUID();
    let data = { project: { _id: projectIdDb2 }, size: size, page: page, searchString: searchText, uuid: uuid, sort: { sortOrder: sortBy, sortBy: "start_time", isActive: titleOnly }, filter: { startedBy: executedBy, createdBy: createdBy, startDate: startDate, endDate: endDate, testArtifacts: testArtifact } };

    if (this.stompProjectExecutionInsertSubscription) {
      this.stompProjectExecutionInsertSubscription.unsubscribe();
    }

    this.stompProjectExecutionInsertSubscription = this.websocketService.stompClient.subscribe('/message/db2/project/exeinsert/' + projectIdDb2, (message) => {
      this.websocketService._senddb2(data);
    });

    if (this.stompProjectExecutionDeleteSubscription) {
      this.stompProjectExecutionDeleteSubscription.unsubscribe();
    }

    this.stompProjectExecutionDeleteSubscription = this.websocketService.stompClient.subscribe('/message/db2/exedelete', (message) => {
      this.websocketService._senddb2(data);
    });

    if (this.stompProjectExecutionUpdateSubscription) {
      this.stompProjectExecutionUpdateSubscription.unsubscribe();
    }
    this.stompProjectExecutionUpdateSubscription = this.websocketService.stompClient.subscribe('/message/db2/project/exeupdate/' + projectIdDb2, (message) => {
      const updatedReport = JSON.parse(message.body).data;
      if (this.filterList && this.filterList.length > 0) {
        this.filterList.forEach((report, index) => {
          if ((report._id["$oid"] ? report._id["$oid"] : report._id) === (updatedReport._id["$oid"] ? updatedReport._id["$oid"] : updatedReport._id)) {
            this.filterList[index] = { ...report, ...updatedReport }; // Update the report with new data
          }
        });
      }

      // Check and update the current report if its _id matches the updated report's _id
      if (this.currentReport._id === updatedReport._id) {
        this.openReport(updatedReport);
      }
    });

    if (this.stompBrowserIterationUpdateSubscription) {
      this.stompBrowserIterationUpdateSubscription.unsubscribe();
    }

    this.stompBrowserIterationUpdateSubscription = this.websocketService.stompClient.subscribe('/message/db2/browserIteration/update', (message) => {
      const updatedBrowserIteration = JSON.parse(message.body).data;
      if (this.currentReport._id === updatedBrowserIteration.report_id["$oid"] ? updatedBrowserIteration.report_id["$oid"] : updatedBrowserIteration.report_id) {
        const liveStatus = this.currentReport.report_links.live_status;
        let updatedBrowser = '';
        let updatedIteration = '';
        for (const [browser, iterations] of Object.entries(liveStatus)) {
          // Iterate through each iteration
          for (const [iteration, value] of Object.entries(iterations)) {
            if (value['_id'] === updatedBrowserIteration['_id']) {
              updatedBrowser = browser;
              updatedIteration = iteration;
              break;
            }
          }
          if (updatedBrowser != '' && updatedIteration != '') {
            break;
          }
        }
        if (updatedBrowser != '' && updatedIteration != '') {
          this.currentReport.report_links.live_status[updatedBrowser][updatedIteration] = JSON.parse(message.body).data;
          this.openReport(this.currentReport);
          // this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
        }
      }
    });

    if (this.stompProjectReportPageSubscription) {
      this.stompProjectReportPageSubscription.unsubscribe();
    }
    this.stompProjectReportPageSubscription = this.websocketService.stompClient.subscribe('/message/db2/id/' + uuid + '/project/' + projectIdDb2 + '/report/page/' + page, (message) => {
      // console.log("message db2",message);
      this.noExecutions = false;
      if (!(JSON.parse(message.body).operationStatus === "ERROR")) {
        if (JSON.parse(message.body).data['list'].length === 0) {
          this.noExecutions = true;
          this.reports = undefined;
        } else {
          this.reports = JSON.parse(message.body).data;
          this.filterList = JSON.parse(JSON.stringify(this.reports['list']))
          if (this.currentReport._id == null) {
            this.currentReportLoading = true;
            if (this.userExecutionId != undefined && this.userExecutionId != null) {
              this.getSelectedReportData(this.userExecutionId);
              this.userExecutionId = null;
            } else {
              this.currentReport = this.filterList[0];
              this.getSelectedReportData(this.filterList[0]._id);
            }
          }
          this.paginationPage = { size: this.reports["totalPages"], currentPage: page };
          this.totalPages = this.reports["totalPages"];
        }
      }
      // this._sharedService.loaderHide.emit(false);
    });
    return this.websocketService._senddb2(data);
  }

   getScheduledReports(size, page, searchText, sortBy, createdBy, executedBy, startDate, endDate, titleOnly, testArtifact) {
    this.noExecutions = false;
    let projectId = localStorage.getItem("projectId");
    let uuid: string = UUID.UUID();
    let data = {
      project: { _id: projectId },
      size: size,
      page: page,
      searchString: searchText,
      uuid: uuid,
      sort: { sortOrder: sortBy, sortBy: "start_time", isActive: titleOnly },
      filter: { startedBy: executedBy, createdBy: createdBy, startDate: startDate, endDate: endDate, testArtifacts: testArtifact }
    };

    // ── Insert: a newly scheduled execution appeared ──────────────────────────
    if (this.stompProjectExecutionInsertSubscription) {
      this.stompProjectExecutionInsertSubscription.unsubscribe();
    }
    this.stompProjectExecutionInsertSubscription = this.websocketService.stompClient.subscribe(
      '/message/db1/project/scheduled/exeinsert/' + projectId,
      () => { this.websocketService._sendScheduled(data); }
    );

    // ── Delete: a scheduled execution was removed ─────────────────────────────
    if (this.stompProjectExecutionDeleteSubscription) {
      this.stompProjectExecutionDeleteSubscription.unsubscribe();
    }
    this.stompProjectExecutionDeleteSubscription = this.websocketService.stompClient.subscribe(
      '/message/db1/scheduled/exedelete',
      () => { this.websocketService._sendScheduled(data); }
    );

    // ── Update: a scheduled execution changed status ──────────────────────────
    if (this.stompProjectExecutionUpdateSubscription) {
      this.stompProjectExecutionUpdateSubscription.unsubscribe();
    }
    this.stompProjectExecutionUpdateSubscription = this.websocketService.stompClient.subscribe(
      '/message/db1/project/scheduled/exeupdate/' + projectId,
      (message) => {
        const updatedReport = JSON.parse(message.body).data;
        if (this.filterList && this.filterList.length > 0) {
          this.filterList.forEach((report, index) => {
            if ((report._id["$oid"] ? report._id["$oid"] : report._id) ===
                (updatedReport._id["$oid"] ? updatedReport._id["$oid"] : updatedReport._id)) {
              this.filterList[index] = { ...report, ...updatedReport };
            }
          });
        }
        if (this.currentReport._id === updatedReport._id) {
          this.openReport(updatedReport);
        }
      }
    );

    // ── Browser-iteration live updates – reuse DB1 channel ───────────────────
    if (this.stompBrowserIterationUpdateSubscription) {
      this.stompBrowserIterationUpdateSubscription.unsubscribe();
    }
    this.stompBrowserIterationUpdateSubscription = this.websocketService.stompClient.subscribe(
      '/message/db1/browserIteration/update',
      (message) => {
        const updatedBrowserIteration = JSON.parse(message.body).data;
        if (this.currentReport._id === (updatedBrowserIteration.report_id["$oid"]
            ? updatedBrowserIteration.report_id["$oid"]
            : updatedBrowserIteration.report_id)) {
          const liveStatus = this.currentReport.report_links.live_status;
          let updatedBrowser = '';
          let updatedIteration = '';
          for (const [browser, iterations] of Object.entries(liveStatus)) {
            for (const [iteration, value] of Object.entries(iterations)) {
              if (value['_id'] === updatedBrowserIteration['_id']) {
                updatedBrowser = browser;
                updatedIteration = iteration;
                break;
              }
            }
            if (updatedBrowser && updatedIteration) break;
          }
          if (updatedBrowser && updatedIteration) {
            this.currentReport.report_links.live_status[updatedBrowser][updatedIteration] = JSON.parse(message.body).data;
            this.openReport(this.currentReport);
          }
        }
      }
    );

    // ── Page response ─────────────────────────────────────────────────────────
    if (this.stompProjectReportPageSubscription) {
      this.stompProjectReportPageSubscription.unsubscribe();
    }
    this.stompProjectReportPageSubscription = this.websocketService.stompClient.subscribe(
      '/message/db1/scheduled/id/' + uuid + '/project/' + projectId + '/report/page/' + page,
      (message) => {
        this.noExecutions = false;
        if (!(JSON.parse(message.body).operationStatus === "ERROR")) {
          if (JSON.parse(message.body).data['list'].length === 0) {
            this.noExecutions = true;
            this.reports = undefined;
          } else {
            this.reports = JSON.parse(message.body).data;
            this.filterList = JSON.parse(JSON.stringify(this.reports['list']));
            if (this.currentReport._id == null) {
              this.currentReportLoading = true;
              if (this.userExecutionId != undefined && this.userExecutionId != null) {
                this.getSelectedReportData(this.userExecutionId);
                this.userExecutionId = null;
              } else {
                this.currentReport = this.filterList[0];
                this.getSelectedReportData(this.filterList[0]._id);
              }
            }
            this.paginationPage = { size: this.reports["totalPages"], currentPage: page };
            this.totalPages = this.reports["totalPages"];
          }
        }
      }
    );

    return this.websocketService._sendScheduled(data);
  }

  getSelectedBrowserIterationData(currentReportId, currentSelectedBrowser, currentSelectedIteration, browserIterationId) {
    this.currentReportLoadFailed = false;
    if (this.stompSelectedBrowserIterationSubscription) {
      this.stompSelectedBrowserIterationSubscription.unsubscribe();
    }
    let uuid: string = UUID.UUID();
    let currentBrowserIterationId: string = browserIterationId["$oid"] ? browserIterationId["$oid"] : browserIterationId;
    this.stompSelectedBrowserIterationSubscription = this.websocketService.stompClient.subscribe('/message/browserIteration/id/' + uuid + '/browserIterationId/' + currentBrowserIterationId, (message) => {
      if (!(JSON.parse(message.body).operationStatus === "ERROR")) {
        if (this.currentReport._id === currentReportId) {
          this.currentReport.report_links.live_status[currentSelectedBrowser][currentSelectedIteration] = JSON.parse(message.body).data;
          this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
          this.isBrowserIterationDataAvailable = true;
          // Extract appium stream URL when browser iteration data is updated
          this.extractAppiumStreamUrl(this.currentReport.report_links);
        }
      } else {
        // error in loading Current Report
        // this.currentReport = null;
        console.log("currentreportLoadFailed......");
        this.currentReportLoadFailed = true;
      }
    });
    let dbName = "db1";
    if (this.viewtype === 'ide') {
      dbName = "db2";
    }
    let data = { browserIterationId: currentBrowserIterationId, execution: { dbName: dbName }, uuid: uuid };

    this.websocketService._sendBrowserIterationId(data);
  }

  getSelectedReportData(reportId) {
    this.currentReportLoading = true;
    const normalizedId: string = reportId["$oid"] ? reportId["$oid"] : reportId;

    let found = (this.filterList || []).find(r => {
      const id = r._id["$oid"] ? r._id["$oid"] : r._id;
      return id === normalizedId;
    });

    if (found) {
      this.currentReport = found;
    } else {
      const report = new ReportModel();
      report._id = reportId;
      this.currentReport = report;
    }

    if (this.currentReport._id != null && this.isExecutionWaiting(this.currentReport)) {
      this.currentReportLoading = false;
    } else {
      this.currentReportLoading = true;
    }

    this.currentReportLoadFailed = false;    
    if (this.stompSelectedReportSubscription) {
      this.stompSelectedReportSubscription.unsubscribe();
    }
    let uuid: string = UUID.UUID();
    this.stompSelectedReportSubscription = this.websocketService.stompClient.subscribe('/message/report/id/' + uuid + '/reportId/' + normalizedId, (message) => {
      if (!(JSON.parse(message.body).operationStatus === "ERROR")) {
        this.openReport(JSON.parse(message.body).data);
        this.currentReportLoading = false;
      } else {
        this.currentReportLoadFailed = true;
        this.currentReportLoading = false;
      }
    });
    let dbName = "db1";
    if (this.viewtype === 'ide') {
      dbName = "db2";
    }
    let data = { execution: { _id: normalizedId, dbName: dbName }, uuid: uuid };

    this.websocketService._sendReportId(data);
  }

  changeScheduledColor() {
    this.isScheduledFilter = !this.isScheduledFilter;
    this.activeScheduledButtonColor = this.isScheduledFilter ? 'lightblue' : 'white';
  }

  ngOnDestroy() {
    if (this.stompProjectExecutionUpdateSubscription) {
      this.stompProjectExecutionUpdateSubscription.unsubscribe();
    }
    if (this.stompProjectExecutionInsertSubscription) {
      this.stompProjectExecutionInsertSubscription.unsubscribe();
    }
    if (this.stompProjectExecutionDeleteSubscription) {
      this.stompProjectExecutionDeleteSubscription.unsubscribe();
    }
    if (this.stompProjectReportPageSubscription) {
      this.stompProjectReportPageSubscription.unsubscribe();
    }
    if (this.stompSelectedReportSubscription) {
      this.stompSelectedReportSubscription.unsubscribe();
    }
    if (this.stompSelectedBrowserIterationSubscription) {
      this.stompSelectedBrowserIterationSubscription.unsubscribe();
    }
    if (this.stompBrowserIterationUpdateSubscription) {
      this.stompBrowserIterationUpdateSubscription.unsubscribe();
    }

    if (this.rfb2 !== undefined && this.rfb2._rfbConnectionState === "connected") {
      this.rfb2._disconnect();
    }
    if (this.heartbeatInterval2) {
      clearInterval(this.heartbeatInterval2);
    }
    this.websocketService._disconnect();
  }

  ngOnInit() {
    this.websocketService._connect();
    this.projectManagementInterated();
    this.getProjectMappingByProjectId();
    this.isUserQA();
    this.route.queryParams.subscribe(params => { this.userExecutionId = params['reportId'];});
    this.websocketService.onConnection().pipe(
      switchMap(data => {
        if (data && this.intialConnectionSuccessful) {
          console.log("wesocket data 2222", data);
          return timer(1000).pipe(switchMap(() => of(data))); // Delay for 1 second and then emit the data
        } else {
          console.log("wesocket data 1111", data);
          return of(data); // Emit the data immediately
        }
      })
    )
      .subscribe(data => {
        if (data) {
          this.intialConnectionSuccessful = true;
          console.log("wesocket data", data);
          if (this.route.snapshot.queryParams['openTab'] == "canvas") {
            this.activeBtn = 'ide';
            this.getReportdb2s(this.size, this.currentPage, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
         } else if (this.route.snapshot.queryParams['openTab'] == Literals.SCHEDULE) {
          this.activeBtn = Literals.SCHEDULE;
          this.viewtype = Literals.SCHEDULE;
          this.getScheduledReports(this.size, this.currentPageSchedule, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
          } else {
            this.activeBtn = 'exe';
            this.getReports(this.size, this.currentPage, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
          }
        }
      });
    // this._sharedService.loaderHide.emit(true);
    this.artifacts = ["Suite", "Feature", "Scenario", "Step"];
    this.dateRangeForm = this.fb.group({
      dateRange: [null] // or initialize with your date range values
    });

    if (this.route.snapshot.queryParams['openTab'] == "canvas") {
      // Set the variable value if the condition is true
      this.viewtype = 'ide';
    } else if (this.route.snapshot.queryParams['openTab'] == Literals.SCHEDULE) {
      this.viewtype = Literals.SCHEDULE;
    }
  }

  ngAfterViewChecked() {
    this.checkAndOpenBrowserLive();
  }

  checkAndOpenBrowserLive() {
    if (this.currentReport.run_status_text === Literals.EXECUTE_FRAMEWORK &&
      this.displayedContent === 'live' &&
      this.currentReport.report_links &&
      this.currentReport.report_links.links) {

      const iteration = this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration];
      const primaryLink = iteration.selenoid_link;
      const secondaryLink = iteration.selenoid_link_2;

      // Handle primary session (always required)
      if (primaryLink) {
        if (this.currentLink !== primaryLink || this.rfb == undefined) {
          this.currentLink = primaryLink;
          this.startClient(primaryLink);
        }
      }

      // Handle secondary session dynamically (may appear later)
      if (secondaryLink && secondaryLink !== '') {
        if (this.currentLink2 !== secondaryLink || this.rfb2 == undefined) {
          this.currentLink2 = secondaryLink;
          this.startClient2(secondaryLink);
        }
      } else if (this.rfb2 !== undefined && this.rfb2._rfbConnectionState === "connected") {
        // Disconnect second session if link is gone
        this.rfb2._disconnect();
        this.currentLink2 = null;
        this.locked2 = false;
      }

    } else {
      // Disconnect both sessions if not in live mode
      if (this.rfb !== undefined && this.rfb._rfbConnectionState === "connected") {
        this.rfb._disconnect();
        this.currentLink = null;
        this.locked = false;
      }
      if (this.rfb2 !== undefined && this.rfb2._rfbConnectionState === "connected") {
        this.rfb2._disconnect();
        this.currentLink2 = null;
        this.locked2 = false;
      }
    }
  }

  public rfb: RFB;
  public rfb2: RFB;
  public activeSession: number = 1;

  startClient(sessionUrl: string) {
    const sessionId = sessionUrl.split("/")[sessionUrl.split("/").length - 1];
    let host = null;

    if (this.currentReport.default_hub) {
      host = environment.selenoidEndpoint;
    } else {
      host = this.currentReport.hub_ip;
    }

    let port = null;
    if (this.currentReport.default_hub) {
      port = 8081;
    }

    const password = "selenoid";
    let path = null;

    if (!this.currentReport.default_hub) {
      path = "ws/vnc/" + sessionId;
    } else {
      path = this.currentReport.hub_ip + "/ws/vnc/" + sessionId;
    }

    let url = null;
    if (this.currentReport.default_hub) {
      url = "ws";
    } else {
      url = "wss";
    }

    url += "://" + host;
    if (port !== null) {
      url += ":" + port;
    }
    url += "/" + path;

    console.log("🔌 VNC URL 1:", url);

    // Creating a new RFB object will start a new connection
    this.rfb = new RFB(document.getElementById("screen"), url, {
      credentials: { password: password },
      wsProtocols: 'binary'
    });

    const sendHeartbeat = () => {
      if (this.rfb && this.rfb._sock) {
        const arr = new Uint8Array(8);
        arr[0] = 6; // Message type: ClientCutText
        arr[1] = 0; // Padding
        arr[2] = 0; // Padding
        arr[3] = 0; // Padding
        arr[4] = 0; // Length (0)
        arr[5] = 0; // Length (0)
        arr[6] = 0; // Length (0)
        arr[7] = 0; // Length (0)
        this.rfb._sock.send(arr); // Send an empty message
      }
    };

    this.rfb.addEventListener('connect', (event) => {
      this.heartbeatInterval = setInterval(sendHeartbeat, 30000);
      this.locked = false;
      this.lockUnlockScreen();
      this.rfb.scaleViewport = true;
    });

    const handleDisconnect = () => {
      this.checkAndOpenBrowserLive();
      if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
      }
    };

    this.rfb.addEventListener('disconnect', handleDisconnect);
  }

  startClient2(sessionUrl: string) {
    const sessionId = sessionUrl.split("/")[sessionUrl.split("/").length - 1];
    let host = null;

    if (this.currentReport.default_hub) {
      host = environment.selenoidEndpoint;
    } else {
      host = this.currentReport.hub_ip;
    }

    let port = null;
    if (this.currentReport.default_hub) {
      port = 8081;
    }

    const password = "selenoid";
    let path = null;

    if (!this.currentReport.default_hub) {
      path = "ws/vnc/" + sessionId;
    } else {
      path = this.currentReport.hub_ip + "/ws/vnc/" + sessionId;
    }

    let url = null;
    if (this.currentReport.default_hub) {
      url = "ws";
    } else {
      url = "wss";
    }

    url += "://" + host;
    if (port !== null) {
      url += ":" + port;
    }
    url += "/" + path;

    console.log("🔌 VNC URL 2:", url);

    // Creating a new RFB object will start a new connection
    this.rfb2 = new RFB(document.getElementById("screen2"), url, {
      credentials: { password: password },
      wsProtocols: 'binary'
    });

    const sendHeartbeat2 = () => {
      if (this.rfb2 && this.rfb2._sock) {
        const arr = new Uint8Array(8);
        arr[0] = 6;
        arr[1] = 0;
        arr[2] = 0;
        arr[3] = 0;
        arr[4] = 0;
        arr[5] = 0;
        arr[6] = 0;
        arr[7] = 0;
        this.rfb2._sock.send(arr);
      }
    };

    this.rfb2.addEventListener('connect', (event) => {
      console.log("✅ VNC Session 2 Connected!");
      this.heartbeatInterval2 = setInterval(sendHeartbeat2, 30000);
      this.locked2 = false;
      this.lockUnlockScreen2();
      this.rfb2.scaleViewport = true;
    });

    const handleDisconnect2 = () => {
      console.log("❌ VNC Session 2 Disconnected");
      this.checkAndOpenBrowserLive();
      if (this.heartbeatInterval2) {
        clearInterval(this.heartbeatInterval2);
      }
    };

    this.rfb2.addEventListener('disconnect', handleDisconnect2);
  }

  lockUnlockScreen() {
    if (this.locked) {
      this.locked = false;
      this.rfb.viewOnly = false;
    } else {
      this.locked = true;
      this.rfb.viewOnly = true;
    }
  }

  lockUnlockScreen2() {
    if (this.locked2) {
      this.locked2 = false;
      this.rfb2.viewOnly = false;
    } else {
      this.locked2 = true;
      this.rfb2.viewOnly = true;
    }
  }

  lockUnlockScreenMobile() {
    // Toggle mobile lock state and sync with mobile stream component
    this.mobileLocked = !this.mobileLocked;
    if (this.mobileStreamComponent) {
      this.mobileStreamComponent.toggleLock();
      this.mobileLocked = this.mobileStreamComponent.isLocked;
    }
  }

  hasSecondSession(): boolean {
    if (this.currentReport.report_links.links && this.selectedBrowser && this.selectedIteration) {
      const iteration = this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration];
      return iteration.selenoid_link_2 !== undefined &&
        iteration.selenoid_link_2 !== null &&
        iteration.selenoid_link_2 !== '';
    }
    return false;
  }

  switchSession(sessionNumber: number) {
    this.activeSession = sessionNumber;
    console.log(`🔄 Switched to Session ${sessionNumber}`);

    // Force resize to ensure proper scaling
    setTimeout(() => {
      if (sessionNumber === 1 && this.rfb) {
        this.rfb.scaleViewport = true;
      } else if (sessionNumber === 2 && this.rfb2) {
        this.rfb2.scaleViewport = true;
      }
    }, 100);
  }

  openReport(ele: ReportModel) {
    // this.index = i
    if (ele) {
      this.ref.detectChanges();
      if (ele._id != this.currentReport._id) {
        this.recentContentType = "";
        this.stepNumberOpened = 0;
        this.selectedStepInStatistic = 0;
        this.stepSelected = false;
        this.lastStepInProgressBrowser = '';
        this.lastStepInProgressIteration = '';
        this.stepBrowserSelected = '';
        this.stepIterationSelected = '';
        this.stepwiseReport = new ReportModel();
        this.video_url = null;
        this.video_url_2 = null
        this.videoNotFound = false;
        this.videoNotFound2 = false;
        this.updatingVideoUrl = false;
        this.updatingVideoUrl2 = false;
        this.datasetAvailable = false;
        this.activeVideoSession = 1;
        this.appium_stream_url = null;
      }
      this.currentReport = JSON.parse(JSON.stringify(ele));
      this.ref.markForCheck();
    }
    // Extract appium stream URL from report links
    if (this.currentReport.report_links) {
      this.extractAppiumStreamUrl(this.currentReport.report_links);
    }
    if (this.currentReport.run_status_text === Literals.EXECUTE_FRAMEWORK) {
      if (this.recentContentType == "" || this.recentContentType == "aborting") {
        this.recentContentType = Literals.STEPEXECUTION;
      }
      this.showContent(this.recentContentType);
    }
    else if (this.currentReport.run_status_text === 'Completed' || this.currentReport.run_status_text === 'Failed' || this.currentReport.run_status_text === 'Execution Failed') {
      if (this.recentContentType == "live" || this.recentContentType == "" || this.recentContentType == "aborting") {
        this.recentContentType = Literals.STATISTIC;
      }
      this.showContent(this.recentContentType);
    }
    else if (this.currentReport.run_status_text === 'Aborted') {
      if (this.recentContentType == "live") {
        this.recentContentType = Literals.STEPEXECUTION;
      } else if ((this.recentContentType == "" || this.recentContentType == Literals.STEPEXECUTION) && this.hasLiveStatus(this.currentReport.report_links)) {
        this.recentContentType = Literals.STEPEXECUTION;
      } else {
        this.recentContentType = "aborted";
      }
      this.showContent(this.recentContentType);
    }
    else if (this.currentReport.run_status_text === 'Aborting') {
      this.recentContentType = "aborting";
      // if (this.recentContentType == "") {
      //   this.recentContentType = "stepexecution";
      // }
      this.showContent(this.recentContentType);
    }
    else if (this.currentReport.run_status_text === 'COMPILATION_ERROR') {
      this.recentContentType = "compilation_error";
      this.showContent(this.recentContentType);
    }
    else {
      this.recentContentType = "";
      this.displayedContent = "";
    }

    if (this.hasLiveStatus(this.currentReport.report_links) && this.objectKeys(this.currentReport.report_links.live_status[this.objectKeys(this.currentReport.report_links.live_status)[0]]).length > 1) {
      this.datasetAvailable = true;
    } else if (this.hasLiveStatus(this.currentReport.report_links) && this.objectKeys(this.currentReport.report_links.live_status[this.objectKeys(this.currentReport.report_links.live_status)[0]]).length == 1) {
      this.http.get(this.restService.apis.isDataSetAvailable.url + this.currentReport._id).subscribe(
        (data: boolean) => {
          this.datasetAvailable = data;
        }
      );
    }

    this.ref.detectChanges();
  }
  public updateShowVideo() {
    this.UrlExists(this.currentReport.report_links.video_link)
  }
  UrlExists(url) {
    const proxyURL = "https://cors-anywhere.herokuapp.com/";
    this.restService.httpGet(proxyURL + url).subscribe(data => {
      if (data) {
        this.showVideo = true;
      }
      else {
        this.showVideo = false;
      }
    })
  }
  rescan(scan_id) {
    this.reportService.restartScan(scan_id).subscribe(data => {
    })
  }
  nextPage() {
    if (this.viewtype === 'ide') {
      this.currentPagedb2++;
      this.getReportdb2s(this.size, this.currentPagedb2, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact)
    }else if (this.viewtype === Literals.SCHEDULE) {
      this.currentPageSchedule++;
      this.getScheduledReports(this.size, this.currentPageSchedule, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
    } 
    else {
      this.currentPage++;
      this.getReports(this.size, this.currentPage, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact)
    }
  }
  PreviousPage() {
    if (this.viewtype === 'ide') {
      this.currentPagedb2--;
      this.getReportdb2s(this.size, this.currentPagedb2, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact)
    } else if (this.viewtype === Literals.SCHEDULE) {
      this.currentPageSchedule--;
      this.getScheduledReports(this.size, this.currentPageSchedule, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
    }
    else {
      this.currentPage--;
      this.getReports(this.size, this.currentPage, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact)
    }
  }
  switch(type) {
    // this._sharedService.loaderHide.emit(true);
    this.currentReport = new ReportModel();
    this.noExecutions = false;
    this.viewtype = type;
    if (type === 'ide') {
      this.filterList = [];
      this.getReportdb2s(this.size, 0, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
      this.activeBtn = type;
    }
    else if (type === Literals.SCHEDULE) {
      this.filterList = [];
      this.getScheduledReports(this.size, 0, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
      this.activeBtn = type;
    } else {
      this.filterList = [];
      this.getReports(this.size, 0, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
      this.activeBtn = type;
    }
  }
  get value(): number {
    return this._value;
  }
  set value(value: number) {
    if (!isNaN(value) && value <= 100) {
    }
  }


  onChangePage($event) {
    if (this.viewtype === 'ide')
     this.getReportdb2s(10, $event, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
   else if (this.viewtype === Literals.SCHEDULE)
      this.getScheduledReports(10, $event, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
    else
      this.getReports(10, $event, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
  }
  getSelenoidLink(object) {
    if (object) {
      if (object.selenoid_link) {
        return object.selenoid_link;
      }
      if (object.selenoid_links) {
        if (object.selenoid_links.length)
          return object.selenoid_links[0];
      }
    }
    else {
      return "";
    }
  }
  private getIterationVideoLinks(iteration: any): { videoLink: string | null, videoLink2: string | null } {
    if (!iteration) {
      return { videoLink: null, videoLink2: null };
    }

    if (iteration.appium_video_links || iteration.appium_video_links_2) {
      return {
        videoLink: iteration.appium_video_links ? iteration.appium_video_links : null,
        videoLink2: iteration.appium_video_links_2 ? iteration.appium_video_links_2 : null
      };
    }

    return {
      videoLink: iteration.video_links ? iteration.video_links : null,
      videoLink2: iteration.video_links_2 ? iteration.video_links_2 : null
    };
  }

  private getVideoMetadataFromReportLinks(reportLinks: any): { videoLink: string | null, videoLink2: string | null } {
    if (!reportLinks) {
      return { videoLink: null, videoLink2: null };
    }

    if (reportLinks.video_link || reportLinks.video_links) {
      return {
        videoLink: reportLinks.video_link ? reportLinks.video_link : reportLinks.video_links,
        videoLink2: reportLinks.video_links ? reportLinks.video_links : null
      };
    }

    return { videoLink: null, videoLink2: null };
  }

  private getVideoFilenameFromLink(link: string | null): string | null {
    if (!link) {
      return null;
    }

    if (link.indexOf("video/") !== -1 && link.indexOf(".mp4") !== -1) {
      return link.split("video/")[1].split(".mp4")[0];
    }

    // If the URL isn’t standard, return as-is so updateVideoUrl can decide
    return link;
  }

  hasVideoLink(object) {
    if (object) {
      if (object.video_links && object.video_links.length) {
        return true;
      }
      if (object.video_link) {
        return true;
      }
      if (object.links && this.selectedBrowser && this.selectedIteration) {
        const iteration = object.links[this.selectedBrowser][this.selectedIteration];
        const { videoLink } = this.getIterationVideoLinks(iteration);
        return videoLink !== null;
      }
      if (this.currentReport.run_status_text === 'Aborted' && this.hasLiveStatus(this.currentReport.report_links)) {
        return true;
      }
    }
    return false;
  }

  //method to check second video link
  hasSecondVideo(): boolean {
    if (this.currentReport && this.currentReport.report_links && this.currentReport.report_links.links && this.selectedBrowser && this.selectedIteration) {
      const iteration = this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration];
      const { videoLink2 } = this.getIterationVideoLinks(iteration);
      return videoLink2 !== null && videoLink2 !== '';
    }
    return false;
  }

  // method to switch video sessions
  switchVideoSession(sessionNumber: number) {
    this.activeVideoSession = sessionNumber;
    console.log(`🔄 Switched to Video Session ${sessionNumber}`);

    // Load video 2 when user switches to it
    if (sessionNumber === 2 && this.video_url_2 === null && this.hasSecondVideo()) {
      this.updateVideoUrl2(this.currentReport.hub_ip,
        this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration]
          .video_links_2.split("video/")[1].split(".mp4")[0]);
    }
  }

  // commented for future release
  // makeReference() {
  //   this.executeService.makeReference(this.currentReport).subscribe(data => {
  //     if (data['operationStatus'] !== 'ERROR') {

  //     } else {

  //     }
  //   })
  // }

  hasSelenoidLink(object) {
    if (object) {
      if (object.selenoid_links) {
        if (object.selenoid_links.length)
          return true;
      }
      if (object.selenoid_link) { return true }
    }
    return false;
  }

  hasAppiumLink(object: any): boolean {
    if (!object || !object.links) {
      return false;
    }

    for (const device in object.links) {
      const sessions = object.links[device];

      for (const key in sessions) {
        if (sessions[key].appium_link) {
          return true;
        }
      }
    }

    return false;
  }

  // Extract and shorten appium_link from nested structure
  extractAppiumStreamUrl(reportLinks: any): void {
    if (!reportLinks || !reportLinks.links) {
      this.appium_stream_url = null;
      return;
    }

    // Iterate through devices and sessions to find appium_link
    for (const device in reportLinks.links) {
      const sessions = reportLinks.links[device];

      for (const iteration in sessions) {
        if (sessions[iteration].appium_link) {
          // Use the appium_link directly from report model — no port stripping
          this.appium_stream_url = sessions[iteration].appium_link;
          return;
        }
      }
    }

    this.appium_stream_url = null;
  }


  hasLiveStatus(object) {
    if (object) {
      if (object.live_status) {
        return true;
      }
    }
    return false;
  }

  stopExecution(event: MouseEvent, report: any) {
    event.stopPropagation();
    this.isIconDisabled = true;
    if (this.viewtype == 'ide') {
      this.executeService.executeStop2(report._id).subscribe(() => {
        report.run_status_text = "Aborting";
        report.selectedBrowser = '';
        report.selectedIteration = '';
        report.report_links = null;
        if (report._id === this.currentReport._id) {
          this.openReport(report);
        }
      });
    } else {
      this.executeService.executeStop(report._id).subscribe(() => {
        report.run_status_text = "Aborting";
        report.selectedBrowser = '';
        report.selectedIteration = '';
        report.report_links = null;
        if (report._id === this.currentReport._id) {
          this.openReport(report);
        }
      });
    }
  }

  getStatusText(status: string): string {
    switch (status) {
      case 'Completed':
        return 'Success';
      case 'Failed':
        return 'Cancelled';
      case 'Aborted':
        return 'Aborted';
      case 'Execution Failed':
        return 'Failed';
      case 'Aborting':
        return 'Aborting';
      case 'COMPILATION_ERROR':
        return 'Error';
      case Literals.STITCH_FRAMEWORK:
      case Literals.GENERATING_CODE:
      case Literals.DEPLOY_FRAMEWORK:
        return 'Initializing'
      case Literals.EXECUTE_FRAMEWORK:
        return 'Inprogress';
      case 'IN_QUEUE':
        return 'In Queue'
      default:
        return 'Configuring Environment';
    }
  }

  hasParamLink(object) {
    if (object) {
      if (object.param_link) { return true }
    }
    return false;
  }
  downloadFile() {
    this.http.get(this.restService.apis.paramdownload.url + this.currentReport._id, {
      responseType: 'blob'
    }).subscribe(data => {
      const blob = new Blob([data], { type: 'application/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'dataset' + '.csv';
      document.body.appendChild(a);
      a.click();
      // window.URL.revokeObjectURL(url);

      // console.log("my url is ", url);


    },
      error => {
        if (error.status === 404) {
          this.notifyservice.notify('error', 'Error', "Dataset does not exists or Deleted")
        } else {
          this.notifyservice.notify('error', 'Error', "Error in downloading dataset")
        }
      }
    );
  }

  downloadLog() {
    this.http.get(this.restService.apis.logFileDownload.url + this.currentReport._id, { responseType: 'text' }).subscribe((data) => {
      window.open(data.toString(), '_blank');
    }, error => {
      if (error.status === 404) {
        this.notifyservice.notify('error', 'Error', "Log does not exists")
      } else {
        this.notifyservice.notify('error', 'Error', "Error in downloading log")
      }
    }
    );
  }

  // showLog() {
  //   window.open(window.location.origin + "/log/" + this.currentReport._id, '_blank');
  // }

  onShareVideoUrl(hubIp: string, filename: string) {
    this.videoShareLink = "";
    this.reportService.getVideoShareUrl(hubIp, filename).subscribe((url: string) => {
      console.log("url from backend uday", url);
      this.videoShareLink = window.location.origin + "/video-viewer/" + url;
      this._sharedService.openOverlayshareTextEvent.emit([true, this.videoShareLink, undefined, hubIp, filename]);
    },
      (error) => {
        this.notifyservice.notify("error", "Error", "Error in generating url...");
      });
  }

  toggledropdown() {
    this.dropdownState = (this.dropdownState === 'closed') ? 'open' : 'closed';
  }
  onSortOptionSelected(option: string) {
    // console.log('Selected Option:', option);
    this.isDropdownVisible = false;
  }
  toggleDropdown() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }
  closeDropdown() {
    this.dropdownState = 'closed';
  }
  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.closeDropdown();
    }
  }
  openDatePicker() {
    this.showDatePickers = !this.showDatePickers;
    // this.datepicker.open();

  }
  selectedDate: Date;
  onDateChanged(event: MatDatepickerInputEvent<Date>) {
    console.log(this.selectedDate);
    console.log(this.dateString);
    this.showDatePickers = false;
    // console.log(event.value);
  }
  onChangeBrowser(valueOfBrowsers) {
    this.video_url = null;
    this.video_url_2 = null;
    this.videoNotFound = false;
    this.videoNotFound2 = false;
    this.updatingVideoUrl = false;
    this.updatingVideoUrl2 = false;
    // console.log("valueOfBrowsers");
    // console.log(valueOfBrowsers.target.value);
    this.selectedBrowser = valueOfBrowsers.target.value;
    if (this.displayedContent === Literals.STEPEXECUTION) {
      this.isBrowserIterationDataAvailable = false;
      if (this.currentReport.run_status_text === Literals.EXECUTE_FRAMEWORK) {
        this.stepSelected = true;
        this.stepBrowserSelected = this.selectedBrowser;
        this.stepIterationSelected = this.stepExecBrowserKeys[this.selectedBrowser][0];
      } else {
        if (this.stepSelected) {
          this.stepSelected = false;
          this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
        }
        this.iterationOptions = this.objectKeys(this.currentReport.report_links.live_status[this.selectedBrowser]);
      }
    } else {
      if (this.stepSelected) {
        this.stepSelected = false;
        this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
      }
      this.iterationOptions = this.objectKeys(this.currentReport.report_links.links[this.selectedBrowser]);
    }
    this.selectedIteration = this.iterationOptions[0];
    this.checkStepwiseDataAndUpdate();
    if (this.selectedBrowser !== this.lastStepInProgressBrowser || this.selectedIteration !== this.lastStepInProgressIteration) {
      this.stepNumberOpened = 1;
    }
    if (this.displayedContent === 'video') {
      const iteration = this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration];
      const { videoLink, videoLink2 } = this.getIterationVideoLinks(iteration);
      const videoFilename = this.getVideoFilenameFromLink(videoLink);
      const videoFilename2 = this.getVideoFilenameFromLink(videoLink2);

      if (videoFilename) {
        this.updateVideoUrl(this.currentReport.hub_ip, videoFilename);
      }
      if (videoFilename2) {
        this.updateVideoUrl2(this.currentReport.hub_ip, videoFilename2);
      }
    }   
  }
  onChangeIteration(valueOfIteration) {
    this.isBrowserIterationDataAvailable = false;
    this.checkStepwiseDataAndUpdate();
    this.video_url = null;
    this.video_url_2 = null;
    this.videoNotFound = false;
    this.videoNotFound2 = false;
    this.updatingVideoUrl = false;
    this.updatingVideoUrl2 = false;
    if (this.displayedContent === Literals.STEPEXECUTION && this.currentReport.run_status_text === Literals.EXECUTE_FRAMEWORK) {
      this.stepSelected = true;
      this.stepBrowserSelected = this.selectedBrowser;
    } else if (this.stepSelected) {
      this.stepSelected = false;
      this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
    }
    this.stepIterationSelected = valueOfIteration.target.value;
    if (this.selectedBrowser !== this.lastStepInProgressBrowser || this.selectedIteration !== this.lastStepInProgressIteration) {
      this.stepNumberOpened = 1;
    }
    if (this.displayedContent === 'video') {
      const iteration = this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration];
      const { videoLink, videoLink2 } = this.getIterationVideoLinks(iteration);
      const videoFilename = this.getVideoFilenameFromLink(videoLink);
      const videoFilename2 = this.getVideoFilenameFromLink(videoLink2);

      if (videoFilename) {
        this.updateVideoUrl(this.currentReport.hub_ip, videoFilename);
      }
      if (videoFilename2) {
        this.updateVideoUrl2(this.currentReport.hub_ip, videoFilename2);
      }
    }
  }

  resetStepExe() {
    this.stepSelected = false;
    this.stepNumberOpened = 0;
    this.isBrowserIterationDataAvailable = false;
    this.selectedBrowser = this.lastStepInProgressBrowser;
    this.selectedIteration = this.lastStepInProgressIteration;
    this.checkStepwiseDataAndUpdate();
    this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
  }

  checkStepwiseDataAndUpdate() {
    if (this.displayedContent === Literals.STEPEXECUTION || this.displayedContent === 'visualcomparison') {
      if (this.currentReport.report_links.live_status == null || this.currentReport.report_links.live_status == undefined) {
        return;
      } else if (this.currentReport.report_links.live_status[this.selectedBrowser][this.selectedIteration]['structure'] != null || this.currentReport.report_links.live_status[this.selectedBrowser][this.selectedIteration]['structure'] != undefined) {
        this.isBrowserIterationDataAvailable = true;
      } else {
        this.getSelectedBrowserIterationData(this.currentReport._id, this.selectedBrowser, this.selectedIteration, this.currentReport.report_links.live_status[this.selectedBrowser][this.selectedIteration]['_id']);
      }
    }
  }

  updateVideoUrl(hubIp: string, filename: string) {
    this.updatingVideoUrl = true;
    let retryCount = 0;
    this.reportService.getVideoContent(hubIp, filename).pipe(
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error: any) => {
            if (error.status === 404 && retryCount < 9) {
              // Increment retry count
              retryCount++;
              // Return an observable that emits after a delay
              return interval(5000).pipe(takeWhile(() => retryCount <= 9));
            } else {
              return throwError(error);
            }
          })
        )
      )
    ).subscribe(
      (videoBlob: Blob) => {
        const videoUrl = URL.createObjectURL(videoBlob);
        this.video_url = videoUrl;
        this.updatingVideoUrl = false;
      },
      (error) => {
        if (error.status === 404) {
          this.videoNotFound = true;
        }
        this.updatingVideoUrl = false;
      }
    );
  }

  showContent(content: string) {
    this.activeContent = content;
    this.displayedContent = content;
    if (this.recentContentType !== content) {
      this.stepSelected = false;
      this.stepwiseReport = new ReportModel();
    }
    this.recentContentType = content;
    this.isDropdownVisible = false;
    this.isDropdownDisabled = false;
    if (content === 'video') {
      this.video_url = null;
      this.video_url_2 = null;
      this.videoNotFound = false;
      this.videoNotFound2 = false;
      this.updatingVideoUrl = false;
      this.updatingVideoUrl2 = false;
      this.activeVideoSession = 1;
      this.isDropdownVisible = true;
      this.isDropdownDisabled = false;

      // Log video link to console on video tab click
      let videoLink = null;
      let videoLink2 = null;

      if (this.currentReport && this.currentReport.report_links && this.currentReport.report_links.links) {
        if (!this.selectedBrowser) {
          const firstBrowser = this.objectKeys(this.currentReport.report_links.links)[0];
          this.selectedBrowser = firstBrowser || '';
        }
        if (!this.selectedIteration && this.selectedBrowser) {
          const iterationKeys = this.objectKeys(this.currentReport.report_links.links[this.selectedBrowser] || {});
          this.selectedIteration = iterationKeys[0] || '';
        }

        if (this.selectedBrowser && this.selectedIteration && this.currentReport.report_links.links[this.selectedBrowser]) {
          const iteration = this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration];
          videoLink = iteration && iteration.video_links ? iteration.video_links : null;
          videoLink2 = iteration && iteration.video_links_2 ? iteration.video_links_2 : null;
        }
      } else {
        videoLink = this.currentReport && this.currentReport.report_links && this.currentReport.report_links.video_link ? this.currentReport.report_links.video_link : null;
        videoLink2 = this.currentReport && this.currentReport.report_links && this.currentReport.report_links.video_links ? this.currentReport.report_links.video_links : null;
      }

    } else if (content === 'live') {
      this.isDropdownVisible = true;
      this.isDropdownDisabled = true;
    } else if (content === Literals.STEPEXECUTION || content === 'visualcomparison') {
      this.isDropdownVisible = true;
      this.isDropdownDisabled = false;
    }

    if (this.currentReport.run_status_text === Literals.EXECUTE_FRAMEWORK && this.currentReport.report_links.live_status) {
      let browserTempKeys = {}
      this.stepNumberOpened = 0;
      let newBrowser: string = "";
      let newInterationNumber: string = "";
      this.objectKeys(this.currentReport.report_links.live_status).forEach((browserName: any) => {
        this.objectKeys(this.currentReport.report_links.live_status[browserName]).forEach(iterNum => {
          if (this.currentReport.report_links.live_status[browserName][iterNum]["status"] === "INPROGRESS") {
            newBrowser = browserName;
            newInterationNumber = iterNum;
            this.lastStepInProgressBrowser = newBrowser;
            this.lastStepInProgressIteration = newInterationNumber;
            if (browserTempKeys[browserName] != undefined) {
              browserTempKeys[browserName].push(iterNum);
            } else {
              browserTempKeys[browserName] = [];
              browserTempKeys[browserName].push(iterNum);
            }
          } else if (this.currentReport.report_links.live_status[browserName][iterNum]["status"] === "PASSED" || this.currentReport.report_links.live_status[browserName][iterNum]["status"] === "FAILED") {
            if (browserTempKeys[browserName] != undefined) {
              browserTempKeys[browserName].push(iterNum);
            } else {
              browserTempKeys[browserName] = [];
              browserTempKeys[browserName].push(iterNum);
            }
          }
        });
      });
      if (content === Literals.STEPEXECUTION) {
        this.isBrowserIterationDataAvailable = false;
        this.stepExecBrowserKeys = browserTempKeys;
        if (this.stepSelected) {
          this.selectedBrowser = this.stepBrowserSelected;
          this.selectedIteration = this.stepIterationSelected;
        } else {
          this.selectedBrowser = newBrowser;
          this.selectedIteration = newInterationNumber;
          this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
        }
        if (this.selectedBrowser == '') {
          this.selectedBrowser = this.lastStepInProgressBrowser;
        }
        if (this.selectedIteration == '') {
          this.selectedIteration = this.lastStepInProgressIteration
        }
        if (this.selectedBrowser !== this.lastStepInProgressBrowser || this.selectedIteration !== this.lastStepInProgressIteration) {
          this.stepNumberOpened = 1;
        }
        this.checkStepwiseDataAndUpdate();
      }
    }

    if ((content === 'live' || content === 'video') && this.currentReport.report_links.links) {
      this.selectedBrowser = this.objectKeys(this.currentReport.report_links.links).pop();
      this.selectedIteration = this.objectKeys(this.currentReport.report_links.links[this.selectedBrowser]).pop();
      this.iterationOptions = this.objectKeys(this.currentReport.report_links.links[this.selectedBrowser]);

      const iteration = this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration];
      const { videoLink, videoLink2 } = this.getIterationVideoLinks(iteration);
      const videoFilename = this.getVideoFilenameFromLink(videoLink);
      const videoFilename2 = this.getVideoFilenameFromLink(videoLink2);

      if (videoFilename) {
        this.updateVideoUrl(this.currentReport.hub_ip, videoFilename);
      }
      if (videoFilename2) {
        this.updateVideoUrl2(this.currentReport.hub_ip, videoFilename2);
      }
      // console.log(this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration].selenoid_link);
    } else if ((content === Literals.STEPEXECUTION && this.currentReport.report_links.live_status) || content === 'visualcomparison') {
      this.isBrowserIterationDataAvailable = false;
      if (this.currentReport.run_status_text === 'Aborted' || this.currentReport.run_status_text === 'Completed' || this.currentReport.run_status_text === 'Failed' || this.currentReport.run_status_text === 'Execution Failed') {
        this.lastStepInProgressBrowser = '';
        this.lastStepInProgressIteration = '';
        if (!this.stepSelected) {
          this.stepwiseReport = JSON.parse(JSON.stringify(this.currentReport));
          this.stepBrowserSelected = '';
          this.stepIterationSelected = '';
          this.stepNumberOpened = 1;
          if (this.selectedStepInStatistic === 0 && this.currentReport.report_links.links != null && this.currentReport.report_links.links != undefined) {
            this.selectedBrowser = this.objectKeys(this.currentReport.report_links.links).pop();
            this.selectedIteration = this.objectKeys(this.currentReport.report_links.links[this.selectedBrowser]).pop();
          } else {
            this.stepNumberOpened = this.selectedStepInStatistic;
            this.selectedStepInStatistic = 0;
          }
        }
        this.isDropdownDisabled = false;
      }

      if (this.selectedBrowser !== "" && this.selectedIteration !== "") {
        this.iterationOptions = this.objectKeys(this.currentReport.report_links.live_status[this.selectedBrowser]);
        this.isDropdownVisible = true;
      } else {
        this.iterationOptions = [];
        this.isDropdownVisible = false;
      }
      this.checkStepwiseDataAndUpdate();
    } else if (content === 'statistic') {
      if (this.currentReport.report_links.links) {
        this.selectedBrowser = this.objectKeys(this.currentReport.report_links.links).pop();
        this.selectedIteration = this.objectKeys(this.currentReport.report_links.links[this.selectedBrowser]).pop();
        this.iterationOptions = this.objectKeys(this.currentReport.report_links.links[this.selectedBrowser]);
      } else {
        this.selectedBrowser = ""
        this.selectedIteration = ""
        this.iterationOptions = []
      }
    } else {
      this.iterationOptions = [];
    }
  }

  // Add new method for updating second video URL
  updateVideoUrl2(hubIp: string, filename: string) {
    this.updatingVideoUrl2 = true;
    let retryCount = 0;
    this.reportService.getVideoContent(hubIp, filename).pipe(
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error: any) => {
            if (error.status === 404 && retryCount < 9) {
              retryCount++;
              return interval(5000).pipe(takeWhile(() => retryCount <= 9));
            } else {
              return throwError(error);
            }
          })
        )
      )
    ).subscribe(
      (videoBlob: Blob) => {
        const videoUrl = URL.createObjectURL(videoBlob);
        this.video_url_2 = videoUrl;
        this.updatingVideoUrl2 = false;
      },
      (error) => {
        if (error.status === 404) {
          this.videoNotFound2 = true;
        }
        this.updatingVideoUrl2 = false;
      }
    );
  }

  getIterationPosition(): string {
    return (parseInt(this.selectedIteration, 10) - 1).toString();
  }

  onChangeToStepwise(eventData: any): void {
    this.selectedBrowser = eventData[0];
    this.selectedIteration = eventData[1];
    this.selectedStepInStatistic = eventData[2];
    this.showContent(Literals.STEPEXECUTION);
  }

  openShareUrlPopup() {
    // Determine which video link to share based on active video session
    const iteration = this.currentReport.report_links.links[this.selectedBrowser][this.selectedIteration];
    const { videoLink, videoLink2 } = this.getIterationVideoLinks(iteration);
    const shareLink = (this.activeVideoSession === 2 && videoLink2) ? videoLink2 : videoLink;
    const videoFilename = this.getVideoFilenameFromLink(shareLink);

    if (videoFilename) {
      this.onShareVideoUrl('dev', videoFilename);
    } else {
      this.notifyservice.notify('error', 'Error', 'Unable to find a shareable video link');
    }
  }

  deleteReport(event: MouseEvent, report: any) {
    event.stopPropagation();
    if (this.viewtype == 'ide') {
      this.executeService.deleteExeReport2(report._id).subscribe(() => {
      })
    } else {
      this.executeService.deleteExeReport(report._id).subscribe(() => {
      })
    }
    report.run_status_text = "Deleting";
  }

  rerunExecution(event: MouseEvent, report: any) {
    event.stopPropagation();
    if (this.currentReport.run_status_text === 'Aborting' || this.currentReport.run_status_text == null
      || this.currentReport.run_status_text == Literals.EXECUTE_FRAMEWORK || this.currentReport.run_status_text == Literals.STITCH_FRAMEWORK
      || this.currentReport.run_status_text == Literals.DEPLOY_FRAMEWORK || this.currentReport.run_status_text == Literals.GENERATING_CODE) {
      return;
    }
    if (this.viewtype == 'ide') {
      this.executeService.executeRerun2(report._id).subscribe(() => {
      })
    } else {
      this.executeService.executeRerun(report._id).subscribe(() => {
      })
    }
    report.report_links = null;
    report.run_status_text = null;
    report.selectedBrowser = '';
    report.selectedIteration = '';
    if (report._id === this.currentReport._id) {
      this.openReport(report);
    }
  }

  showCreated() {
    this.showCreatedDiv = !this.showCreatedDiv;
    this.getData().subscribe(data => {
      this.usernames = data['data'].map(item => item.username);
      // preserve original list for filtering
      this.filteredCreatedNames = this.usernames;
    })
  }

  showExecuted() {
    this.showExecutedDiv = !this.showExecutedDiv;
    this.getData().subscribe(data => {
      this.usernames = data['data'].map(item => item.username)
    })
    this.filteredExecutedNames = this.usernames;
    console.log(this.usernames);
  }

  getData() {
    return this.restService.get("allUser", null);
  }

  toggleCreateSelection(name: string) {
    this.selectedCreatedUsers[name] = !this.selectedCreatedUsers[name];
    this.createdBy = Object.keys(this.selectedCreatedUsers).filter(key =>
      this.selectedCreatedUsers[key] === true
    );
  }

  toggleExecuteSelection(name: string) {
    this.selectedExecutedUsers[name] = !this.selectedExecutedUsers[name];
    this.startedBy = Object.keys(this.selectedExecutedUsers).filter(key =>
      this.selectedExecutedUsers[key] === true
    );
    console.log(this.startedBy);
  }

  setSortingDirection(direction: string) {
    this.sortBy = direction == null ? "desc" : direction;
  }

  filteredExecutedNames: string[] = [];
  filteredCreatedNames: string[] = [];
  searchExecutedTerm: string = '';
  searchCreatedTerm: string = '';

  updateFilter() {
    if (this.searchExecutedTerm.trim() === '') {
      // If the search term is empty, show all names
      this.usernames = this.filteredExecutedNames;
    }
    else {
      this.usernames = this.usernames.filter(name =>
        name.toLowerCase().includes(this.searchExecutedTerm.toLowerCase())
      );
    }
  }

  updateCreatedFilter() {
    if (!this.searchCreatedTerm || this.searchCreatedTerm.trim() === '') {
      this.usernames = this.filteredCreatedNames;
    } else {
      this.usernames = (this.filteredCreatedNames || []).filter(name =>
        name.toLowerCase().includes(this.searchCreatedTerm.toLowerCase())
      );
    }
  }

  showArtifacts() {
    this.showArtifact = !this.showArtifact;
  }


  artifactClicked: any;
  toggleArtifactSelection(name: string) {
    this.selectedArtifact[name] = !this.selectedArtifact[name];
    this.artifactClicked = Object.keys(this.selectedArtifact).filter(key =>
      this.selectedArtifact[key] === true
    );
    this.testArtifact = this.artifactClicked == null ? null : this.artifactClicked;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const target = event.target as Node;

    // If Created dropdown is open, close it when clicking outside the dropdown AND outside the created button
    if (this.showCreatedDiv) {
      const clickedInsideCreated = this.createdDivRef && this.createdDivRef.nativeElement && this.createdDivRef.nativeElement.contains(target);
      const clickedOnCreatedBtn = this.createdBtnRef && this.createdBtnRef.nativeElement && this.createdBtnRef.nativeElement.contains(target);
      if (!clickedInsideCreated && !clickedOnCreatedBtn) {
        this.showCreatedDiv = false;
      }
    }

    // Executed dropdown
    if (this.showExecutedDiv) {
      const clickedInsideExecuted = this.executedDivRef && this.executedDivRef.nativeElement && this.executedDivRef.nativeElement.contains(target);
      const clickedOnExecutedBtn = this.executedBtnRef && this.executedBtnRef.nativeElement && this.executedBtnRef.nativeElement.contains(target);
      if (!clickedInsideExecuted && !clickedOnExecutedBtn) {
        this.showExecutedDiv = false;
      }
    }

    // Artifact dropdown
    if (this.showArtifact) {
      const clickedInsideArtifact = this.artifactDivRef && this.artifactDivRef.nativeElement && this.artifactDivRef.nativeElement.contains(target);
      const clickedOnArtifactBtn = this.artifactBtnRef && this.artifactBtnRef.nativeElement && this.artifactBtnRef.nativeElement.contains(target);
      if (!clickedInsideArtifact && !clickedOnArtifactBtn) {
        this.showArtifact = false;
      }
    }

    // Sort dropdown: close when clicking outside sort button and sort menu
    if (this.showsortDiv) {
      const clickedInsideSort = this.sortDivRef && this.sortDivRef.nativeElement && this.sortDivRef.nativeElement.contains(target);
      const clickedOnSortBtn = this.sortBtnRef && this.sortBtnRef.nativeElement && this.sortBtnRef.nativeElement.contains(target);
      if (!clickedInsideSort && !clickedOnSortBtn) {
        this.showsortDiv = false;
      }
    }

    // Date picker: close when clicking outside the date picker container and outside the date toggle button
    if (this.showDatePickers) {
      const clickedInsideDate = this.dateDivRef && this.dateDivRef.nativeElement && this.dateDivRef.nativeElement.contains(target);
      const clickedOnDateBtn = this.dateBtnRef && this.dateBtnRef.nativeElement && this.dateBtnRef.nativeElement.contains(target);
      if (!clickedInsideDate && !clickedOnDateBtn) {
        this.showDatePickers = false;
      }
    }

    // If click occurred completely outside this component, close global dropdowns
    if (!this.el.nativeElement.contains(target)) {
      this.showsortDiv = false;
      // also ensure date pickers close when clicking completely outside
      this.showDatePickers = false;
    }
  }

  applyFilter() {
    this.showDiv = !this.showDiv;
    if (this.viewtype == 'ide')
      this.getReportdb2s(this.size, 0, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
    else if (this.viewtype == Literals.SCHEDULE)
      this.getScheduledReports(this.size, 0, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
    else
      this.getReports(this.size, 0, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
  }

  /**
   * Reset all filters to their default (fresh) state and refresh the list.
   * Does not clear the main search input (`searchText`) since that feels
   * like a primary search value; only filter criteria are reset.
   */
  resetFilters() {
    // Close filter panel
    this.showDiv = false;

    // Reset created/executed selections
    this.selectedCreatedUsers = {};
    this.selectedExecutedUsers = {};
    this.createdBy = null;
    this.startedBy = [];
    this.searchCreatedTerm = '';
    this.searchExecutedTerm = '';
    this.filteredCreatedNames = [];
    this.filteredExecutedNames = [];

    // Reset artifact selections
    this.selectedArtifact = {};
    this.testArtifact = [];
    this.showArtifact = false;

    // Reset sort & title-only toggle
    this.showsortDiv = false;
    this.sortBy = 'desc';
    this.isActive = false;
    this.activeButtonColor = 'white';

    // Reset date pickers
    this.showDatePickers = false;
    this.startDate = undefined;
    this.endDate = undefined;

    // Close created/executed dropdowns if open
    this.showCreatedDiv = false;
    this.showExecutedDiv = false;

    // Inside resetFilters(), alongside the other resets:
    this.isScheduledFilter = false;
    this.activeScheduledButtonColor = 'white';

    // Refresh the list with cleared filters (page 0)
    if (this.viewtype == 'ide') {
      this.getReportdb2s(this.size, 0, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
     } else if (this.viewtype == Literals.SCHEDULE) {
      this.getScheduledReports(this.size, 0, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
      } else {
      this.getReports(this.size, 0, this.searchText, this.sortBy, this.createdBy, this.startedBy, this.startDate, this.endDate, this.isActive, this.testArtifact);
    }
  }

  getLast7Days() {
    this.calculateLastNDays(7);
  }

  getLast30Days() {
    this.calculateLastNDays(30);
  }

  getLast90Days() {
    this.calculateLastNDays(90);
  }

  calculateLastNDays(days: number) {
    const currentDate = new Date();
    this.endDate = new Date();
    currentDate.setDate(currentDate.getDate() - days);
    this.startDate = currentDate;
  }

  changeColor() {
    this.isActive = !this.isActive;
    if (this.isActive)
      this.activeButtonColor = 'lightblue';
    else
      this.activeButtonColor = 'white';
  }

  showRaiseBug = false;

  displayRaiseBugComponent() {
    this.showRaiseBug = true;
  }

  closeRaiseBugComponent() {
    this.showRaiseBug = false;
  }

  projectManagementInterated() {
    this.reportService.getProjectManagementTypesForUser().subscribe(res => {
      // Check if 'data' field is not empty
      if (res.data && res.data.length > 0) {
        this.isProjectManagementIntegrated = true;
      } else {
        this.isProjectManagementIntegrated = false;
      }
    });
  }

  getProjectMappingByProjectId() {
    let projectId = localStorage.getItem("projectId");
    this.reportService.getProjectMappingByProjectId(projectId).subscribe(res => {
      if (res.operationStatus === 'SUCCESS') {
        this.isProjectMapped = true;
      }
    });
  }

  openGenerateTestCase(event: MouseEvent, report: any) {
    event.stopPropagation();
    const reportId = report && report._id;
    const url = this.router.serializeUrl(this.router.createUrlTree(['/generate-test-case', reportId]));
    window.open(url, '_blank');
  }

  isExecutionWaiting(report: any): boolean {
    return (
      (report.run_status === 1 && report.run_status_text == null) ||
      new Set([
        Literals.GENERATING_CODE,
        Literals.STITCH_FRAMEWORK,
        Literals.DEPLOY_FRAMEWORK,
      ]).has(report.run_status_text) ||
      (
        report.run_status_text === Literals.EXECUTE_FRAMEWORK &&
        !this.hasExecutionStarted(report)
      )
    );
  }

  hasExecutionStarted(report: any): boolean {
    return (
      report.report_links &&
      report.report_links.links &&
      Object.keys(report.report_links.links).length > 0
    );
  }

isUserQA(){
  this.userService.checkUserQaRole().subscribe((response)=>{
   if (response.operationStatus === "SUCCESS") {
      this.isUserQa = response.data === true;
    } else {
      this.isUserQa = false;
    }
  }, error => {
    console.error("API Error:", error);
    this.isUserQa = false; // fallback
  });
}
} 
